<!-- Spacer -->
<div
    class="cb-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
